import React from 'react'
import { mount } from 'enzyme'
import { MultiSelect } from '../../elements'

describe("Component: MultiSelect", () => {
  let wrapper, instance, props, result

  beforeAll(() => {
    props = {
      id: 'id-1',
      options: [
        ['Florida', 'FL']
      ],
      value: null,
      resolveOutput: val => result = val
    }
    wrapper = mount(<MultiSelect {...props} />)
    instance = wrapper.instance()
  })

  describe('#filterByValue', () => {
    describe('when no value present', () => {
      it('should return array', () => {
        const { filterByValue } = instance

        expect(filterByValue.length).toBe(1)
      })
    })

    describe('when value present', () => {
      beforeAll(() => {
        instance.onChange({ target: { value: 'De' } })
      })
      it('should return array', () => {
        const { filterByValue } = instance

        expect(filterByValue.length).toBe(0)
      })
    })
  })

  describe('#placeholder', () => {
    describe('when no prop present', () => {
      it('should return array', () => {
        const { placeholder } = instance

        expect(placeholder).toBe('Search for option')
      })
    })

    describe('when prop present', () => {
      beforeAll(() => {
        wrapper.setProps({ placeholder: 'place' })
      })
      it('should return array', () => {
        const { placeholder } = instance

        expect(placeholder).toBe('place')
      })
    })
  })

  describe('#prepareValue', () => {
    describe('when no prop present', () => {
      it('should return array', () => {
        instance.prepareValue()

        expect(instance.state.values.length).toBe(0)
      })
    })

    describe('when prop present', () => {
      beforeAll(() => {
        wrapper.setProps({ value: 'place' })
      })
      it('should return array', () => {
        instance.prepareValue()

        expect(instance.state.values.length).toBe(1)
      })
    })
  })

  describe('#clearValues', () => {
    let handleClickOutside, resolveOutput
    beforeEach(() => {
      handleClickOutside = spyOn(instance, 'handleClickOutside')
      resolveOutput = spyOn(instance, 'resolveOutput')
      instance.state.values = ['test']
    })

    it('should call functions and set value', () => {
      instance.clearValues()

      expect(handleClickOutside).toHaveBeenCalled()
      expect(resolveOutput).toHaveBeenCalled()
      expect(instance.state.values.length).toBe(0)
    })
  })

  describe('#handleClickOutside', () => {
    let setShowList
    beforeEach(() => {
      setShowList = spyOn(instance, 'setShowList')
      instance.state.searchValue = 'test'
    })

    it('should call functions and set value', () => {
      instance.handleClickOutside({ reset: true })

      expect(setShowList).toHaveBeenCalled()
      expect(instance.state.searchValue).toBe('')
    })
  })

  describe('#resolveOutput', () => {
    it('should call functions and set value', () => {
      const response = instance.resolveOutput( ['Fiji'])

      expect(result[0]).toBe('Fiji')
      expect(response[0]).toBe('Fiji')
    })
  })

  describe('#renderIcon', () => {
    it('should return obj', () => {
      const obj = instance.renderIcon()

      expect(obj).toBeTruthy()
      expect(typeof obj).toBe('object')
    })
  })

  describe('#renderValues', () => {
    it('should return obj', () => {
      const obj = instance.renderValues()

      expect(obj).toBeTruthy()
      expect(typeof obj).toBe('object')
    })
  })

  describe('#renderTag', () => {
    it('should return obj', () => {
      const obj = instance.renderTag('foo')

      expect(obj).toBeTruthy()
      expect(typeof obj).toBe('object')
    })
  })

  describe('#renderList', () => {
    it('should return obj', () => {
      const obj = instance.renderList('foo')

      expect(obj).toBeTruthy()
      expect(typeof obj).toBe('object')
    })
  })

  describe('#setShowList', () => {
    describe('when set to true', () => {
      it('should return obj', () => {
        instance.setShowList(true)

        expect(instance.state.showList).toBeTruthy()
      })
    })

    describe('when set to false', () => {
      it('should return obj', () => {
        instance.setShowList(false)

        expect(instance.state.showList).toBeFalsy()
      })
    })
  })

  describe('#removeValue', () => {
    let resolveOutput
    beforeEach(() => {
      resolveOutput = spyOn(instance, 'resolveOutput')
      instance.state.values = ['foo']
    })

    it('should call functions and set value', () => {
      expect(instance.state.values[0]).toBe('foo')
      instance.removeValue('foo')

      expect(resolveOutput).toHaveBeenCalled()
      expect(instance.state.values[0]).toBeFalsy()
    })
  })

  describe('#addValues', () => {
    let handleClickOutside, resolveOutput
    beforeEach(() => {
      handleClickOutside = spyOn(instance, 'handleClickOutside')
      resolveOutput = spyOn(instance, 'resolveOutput')
      instance.state.values = []
    })

    describe('when value is not included in array', () => {
      it('should call functions and set value', () => {
        instance.addValues('foo')

        expect(handleClickOutside).toHaveBeenCalled()
        expect(resolveOutput).toHaveBeenCalled()
        expect(instance.state.values[0]).toBe('foo')
      })
    })

    describe('when value is included in array', () => {
      beforeEach(() => {
        instance.state.values = ['foo']
      })

      it('should call functions and set value', () => {
        instance.addValues('foo')

        expect(handleClickOutside).toHaveBeenCalled()
        expect(resolveOutput).not.toHaveBeenCalled()
        expect(instance.state.values[0]).toBe('foo')
      })
    })
  })

  describe('#onChange', () => {
    it('should set value', () => {
      expect(instance.state.searchValue).toBe('')
      instance.onChange({ target: { value: 'value' } })

      expect(instance.state.searchValue).toBe('value')
    })
  })

})